/**
 * WC-07: Streak Display Component
 *
 * Shows the user's current streak and week progress.
 */

import React from 'react';
import './StreakDisplay.css';

interface StreakDisplayProps {
  currentStreak: number;
  daysCompleted: number;
  totalDays: number;
  totalStars: number;
  maxStars: number;
}

export const StreakDisplay: React.FC<StreakDisplayProps> = ({
  currentStreak,
  daysCompleted,
  totalDays,
  totalStars,
  maxStars,
}) => {
  return (
    <div className="streak-display">
      <div className="streak-stat">
        <span className="streak-icon">🔥</span>
        <span className="streak-value">{currentStreak}</span>
        <span className="streak-label">Day Streak</span>
      </div>

      <div className="streak-divider" />

      <div className="streak-stat">
        <span className="streak-icon">📊</span>
        <span className="streak-value">{daysCompleted}/{totalDays}</span>
        <span className="streak-label">Complete</span>
      </div>

      <div className="streak-divider" />

      <div className="streak-stat">
        <span className="streak-icon">⭐</span>
        <span className="streak-value">{totalStars}/{maxStars}</span>
        <span className="streak-label">Stars</span>
      </div>
    </div>
  );
};
